import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { theme } from '@dtx-company/shared-components/src'
import styled from 'styled-components'

export const InfiniteScrollWrapper = styled(Box)`
  .infinite-scroll-component__outerdiv {
    width: 100%;
  }
`

export const MenuItemWrapper = styled(Box)`
  flex-direction: column;
  justify-content: center;
  border: 0.5px solid ${theme.colors.secondary.border};
  border-radius: 4px;
  font-weight: bold;
`
